import {useEffect, useRef} from "react";

export const usePrevious = (value) => {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

export const useSounds = () => {
    const ref = useRef();
    useEffect(() => {
        const t = setTimeout(() => {
            ref.current = true;
            clearTimeout(t);
        }, 1000)
    }, []);
    return ref.current;
}

export const throttle = (func, timeFrame) => {
    let lastTime = 0;
    return function () {
        let now = new Date().getTime();
        if (now - lastTime >= timeFrame) {
            func();
            lastTime = now;
        }
    };
}
